export default class Followers {
  constructor(args) {
    console.log('followers.js loaded');
    let button_menu = document.getElementById('show_follow_menu'),
        target = document.getElementById(button_menu.getAttribute('data-toggle'));

    button_menu.onclick = function() {
      target.classList.toggle("is-open");
    }
  }

  // methods
}



// WEBPACK FOOTER //
// ./pages/followers.js